// PGCET MCA Mock 2 — General Awareness (questions 71–90)
const pgcetmcaGeneralAwareness = [
  {
    id: 71,
    question: "Article 21 of the Constitution of India guarantees",
    options: [
      "A. Equality before law",
      "B. Freedom of speech and expression",
      "C. Protection of life and personal liberty",
      "D. Right to constitutional remedies"
    ],
    answer: "C"
  },
  {
    id: 72,
    question: "The Reserve Bank of India was established in",
    options: ["A. 1947", "B. 1935", "C. 1949", "D. 1950"],
    answer: "B"
  },
  {
    id: 73,
    question: "The repo rate is the rate at which",
    options: [
      "A. commercial banks lend to their best customers",
      "B. the RBI borrows from commercial banks",
      "C. banks pay interest on savings accounts",
      "D. the RBI lends short-term funds to commercial banks against government securities"
    ],
    answer: "D"
  },
  {
    id: 74,
    question: "The Goods and Services Tax (GST) came into effect in India on",
    options: ["A. 1 July 2017", "B. 1 April 2017", "C. 8 November 2016", "D. 1 January 2018"],
    answer: "A"
  },
  {
    id: 75,
    question: "Which of the following is a direct tax?",
    options: ["A. Goods and Services Tax", "B. Customs duty", "C. Excise duty", "D. Income tax"],
    answer: "D"
  },
  {
    id: 76,
    question: `Match List-I with List-II.
      List-I: (a) Sensex (b) Nifty 50 (c) SEBI (d) NABARD
      List-II: (i) Index of the National Stock Exchange (ii) Index of the Bombay Stock Exchange (iii) Regulator of the securities market (iv) Finance for agriculture and rural development`,
    options: [
      "A. a-i, b-ii, c-iii, d-iv",
      "B. a-ii, b-i, c-iii, d-iv",
      "C. a-ii, b-i, c-iv, d-iii",
      "D. a-iii, b-iv, c-i, d-ii"
    ],
    answer: "B"
  },
  {
    id: 77,
    question: "Chandrayaan-3's lander touched down near the lunar south pole in",
    options: ["A. July 2019", "B. September 2022", "C. August 2023", "D. January 2024"],
    answer: "C"
  },
  {
    id: 78,
    question: "The headquarters of the World Bank is located in",
    options: ["A. Washington, D.C.", "B. New York", "C. Geneva", "D. Paris"],
    answer: "A"
  },
  {
    id: 79,
    question: "The 'Make in India' initiative was launched by the Government of India in",
    options: ["A. 2012", "B. 2014", "C. 2016", "D. 2018"],
    answer: "B"
  },
  {
    id: 80,
    question: "The SI unit of electrical resistance is the",
    options: ["A. Volt", "B. Ampere", "C. Watt", "D. Ohm"],
    answer: "D"
  },
  {
    id: 81,
    question: "Scurvy is caused by a deficiency of",
    options: ["A. Vitamin A", "B. Vitamin C", "C. Vitamin D", "D. Vitamin K"],
    answer: "B"
  },
  {
    id: 82,
    question: "Which planet of the solar system rotates fastest on its axis, giving it the shortest day?",
    options: ["A. Earth", "B. Mars", "C. Jupiter", "D. Venus"],
    answer: "C"
  },
  {
    id: 83,
    question: "'The Discovery of India' was written by",
    options: ["A. Jawaharlal Nehru", "B. Mahatma Gandhi", "C. Rabindranath Tagore", "D. B. R. Ambedkar"],
    answer: "A"
  },
  {
    id: 84,
    question: `Consider the following statements about the Unified Payments Interface (UPI).
      (a) UPI was developed by the National Payments Corporation of India (NPCI).
      (b) UPI allows bank-to-bank transfers at any time of day, on all days.
      (c) UPI is operated by the Securities and Exchange Board of India (SEBI).
      Which of the statements are correct?`,
    options: ["A. (a) and (c) only", "B. (b) and (c) only", "C. (a), (b) and (c)", "D. (a) and (b) only"],
    answer: "D"
  },
  {
    id: 85,
    question: "The RBI's flexible inflation targeting framework sets its inflation target in terms of",
    options: ["A. the Wholesale Price Index (WPI)", "B. the Consumer Price Index (Combined)", "C. the GDP deflator", "D. the Index of Industrial Production"],
    answer: "B"
  },
  {
    id: 86,
    question: "An 'angel investor' is best described as",
    options: [
      "A. a bank that gives secured loans to large companies",
      "B. a government agency that funds public infrastructure",
      "C. an individual who provides early-stage capital to a startup, usually in exchange for equity",
      "D. an investor who buys only government bonds"
    ],
    answer: "C"
  },
  {
    id: 87,
    question: "Which of the following is an example of a business-to-business (B2B) transaction?",
    options: [
      "A. A steel manufacturer selling steel sheets to a car maker",
      "B. A customer buying a phone from an online store",
      "C. A person selling a used bicycle to a neighbour",
      "D. A citizen paying property tax online"
    ],
    answer: "A"
  },
  {
    id: 88,
    question: "The fiscal deficit of a government is",
    options: [
      "A. total receipts minus total expenditure",
      "B. revenue expenditure minus revenue receipts",
      "C. the interest paid on past borrowings",
      "D. total expenditure minus total receipts excluding borrowings"
    ],
    answer: "D"
  },
  {
    id: 89,
    question: "The Preamble of the Constitution of India describes India as a",
    options: [
      "A. Sovereign Democratic Federal Republic",
      "B. Sovereign Socialist Secular Democratic Republic",
      "C. Secular Socialist Federal Democratic Union",
      "D. Sovereign Secular Democratic Monarchy"
    ],
    answer: "B"
  },
  {
    id: 90,
    question: "Kaziranga National Park, famous for the one-horned rhinoceros, is located in",
    options: ["A. West Bengal", "B. Odisha", "C. Assam", "D. Madhya Pradesh"],
    answer: "C"
  }
];

export default pgcetmcaGeneralAwareness;
